import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import giftingReducer from "./giftingReducer";
import plansReducer from "./masterDataReducers/plansReducer";
import userGeoLocationReducer from "./userGeoLocationReducer";

const allReducers = combineReducers({
    auth: authReducer,
    plans: plansReducer,
    userGeoLocation: userGeoLocationReducer,
    gifting: giftingReducer
})

export default allReducers;